var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLightningSniper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 73,
    viewBox: "0 0 94 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6562,
    y: 0.168945,
    width: 64,
    height: 64,
    rx: 16,
    fill: "white",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.746 51.5985C58.2037 51.5985 67.492 42.3102 67.492 30.8524C67.492 19.3947 58.2037 10.1064 46.746 10.1064C35.2883 10.1064 26 19.3947 26 30.8524C26 42.3102 35.2883 51.5985 46.746 51.5985Z",
    fill: "url(#paint0_linear_734_766)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip1_734_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2496 19.1454C40.3621 19.1454 34.7559 24.6855 34.7559 31.4917C34.7559 38.2978 40.3621 43.8379 47.2496 43.8379C54.1371 43.8379 59.7434 38.2978 59.7434 31.4917C59.7434 24.6855 54.1371 19.1454 47.2496 19.1454ZM47.2496 43.035C40.8121 43.035 35.5684 37.8593 35.5684 31.4917C35.5684 25.124 40.8121 19.9483 47.2496 19.9483C53.6871 19.9483 58.9309 25.124 58.9309 31.4917C58.9309 37.8593 53.6871 43.035 47.2496 43.035Z",
    fill: "url(#paint1_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 47.8711H46.9375V46.9817H47.5625V47.8711Z",
    fill: "url(#paint2_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9375 46.6113V36.5071C47.0375 36.5132 47.1437 36.5194 47.25 36.5194C47.3562 36.5194 47.4563 36.5132 47.5625 36.5071V46.6113H46.9375Z",
    fill: "url(#paint3_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 16.2488V26.4766C47.4563 26.4704 47.3562 26.4642 47.25 26.4642C47.1437 26.4642 47.0375 26.4642 46.9375 26.4766V16.2488H47.5625Z",
    fill: "url(#paint4_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 15.8784H46.9375V15.1126H47.5625V15.8784Z",
    fill: "url(#paint5_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4061 31.8008H30.6748V31.1832H31.4061V31.8008Z",
    fill: "url(#paint6_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0749 31.8008H31.7749V31.1832H38.0749V31.8008Z",
    fill: "url(#paint7_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9248 31.8008H38.4561V31.1832H38.9248V31.8008Z",
    fill: "url(#paint8_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1747 31.8008H39.2935V31.1832H42.1747C42.1685 31.282 42.1622 31.387 42.1622 31.492C42.1685 31.597 42.1685 31.6958 42.1747 31.8008Z",
    fill: "url(#paint9_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.906 31.1832V31.8008H52.3247C52.331 31.6958 52.3372 31.597 52.3372 31.492C52.3372 31.387 52.3372 31.282 52.3247 31.1832H54.906Z",
    fill: "url(#paint10_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7812 31.8008H55.2812V31.1832H55.7812V31.8008Z",
    fill: "url(#paint11_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5062 31.8008H56.1562V31.1832H62.5062V31.8008Z",
    fill: "url(#paint12_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8246 31.8008H62.8809V31.1832H63.8246V31.8008Z",
    fill: "url(#paint13_linear_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6185 27.7304C49.7935 27.0078 48.731 26.5508 47.5685 26.4767C47.4622 26.4705 47.3622 26.4643 47.256 26.4643C47.1497 26.4643 47.0435 26.4643 46.9435 26.4767C45.7747 26.5446 44.7122 27.0078 43.8872 27.7304L43.4872 27.3351C44.4122 26.5137 45.6185 25.9887 46.9372 25.9208C47.0372 25.9146 47.1435 25.9146 47.2497 25.9146C47.356 25.9146 47.456 25.9146 47.5622 25.9208C48.881 25.9949 50.0872 26.5137 51.0122 27.3351L50.6185 27.7304ZM43.4435 34.8145L43.0435 35.2098C42.2122 34.2957 41.681 33.1037 41.6122 31.8005C41.606 31.6955 41.606 31.5967 41.606 31.4917C41.606 31.3867 41.6122 31.2817 41.6122 31.1829C41.6872 29.8736 42.2122 28.6877 43.0435 27.7737L43.4435 28.1689C42.7122 28.9842 42.2497 30.0342 42.1747 31.1891C42.1685 31.2879 42.1622 31.3929 42.1622 31.4979C42.1622 31.6029 42.1685 31.7017 42.1747 31.8067C42.2435 32.9555 42.7122 34.0055 43.4435 34.8145ZM52.8872 31.8005C52.8185 33.1099 52.2872 34.2957 51.456 35.2098L51.056 34.8145C51.7872 33.9993 52.2497 32.9493 52.3247 31.8005C52.331 31.6955 52.3372 31.5967 52.3372 31.4917C52.3372 31.3867 52.3372 31.2817 52.3247 31.1829C52.256 30.028 51.7872 28.978 51.056 28.1628L51.456 27.7675C52.2872 28.6816 52.8185 29.8736 52.8872 31.1767C52.8935 31.2756 52.8935 31.3806 52.8935 31.4856C52.8997 31.5967 52.8935 31.6955 52.8872 31.8005ZM47.5622 37.0627C47.456 37.0688 47.356 37.0688 47.2497 37.0688C47.1435 37.0688 47.0372 37.0627 46.9372 37.0627C45.6122 36.9886 44.4122 36.4698 43.4872 35.6483L43.8872 35.253C44.7122 35.9757 45.7747 36.4327 46.9435 36.5068C47.0435 36.513 47.1497 36.5192 47.256 36.5192C47.3622 36.5192 47.4622 36.513 47.5685 36.5068C48.7372 36.4389 49.7997 35.9757 50.6185 35.253L51.0185 35.6483C50.0872 36.4698 48.8872 36.9886 47.5622 37.0627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2496 30.4791C47.8157 30.4791 48.2746 30.9326 48.2746 31.492C48.2746 32.0514 47.8157 32.5049 47.2496 32.5049C46.6835 32.5049 46.2246 32.0514 46.2246 31.492C46.2246 30.9326 46.6835 30.4791 47.2496 30.4791Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.7764 54.9556C41.9204 64.2705 34.4858 71.9385 25.171 72.0825C15.8561 72.2265 8.18806 64.792 8.04405 55.4771C7.90005 46.1621 15.3346 38.4942 24.6495 38.3502C33.9644 38.2061 41.6324 45.6406 41.7764 54.9556Z",
    fill: "url(#paint14_radial_734_766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3663 47.833C89.2107 48.287 88.8218 48.7043 88.1153 49.0553C87.4067 49.4074 86.4225 49.6693 85.1699 49.8268C82.6667 50.1416 79.2062 50.0263 75.0196 49.4962C66.6548 48.4372 55.4988 45.7366 43.541 41.6397C31.5833 37.543 21.115 32.8351 13.8581 28.5421C10.2261 26.3934 7.42189 24.3624 5.6377 22.5788C4.7448 21.6862 4.12798 20.8757 3.7842 20.1632C3.44136 19.4527 3.39004 18.8846 3.54559 18.4305C3.70115 17.9765 4.09005 17.5593 4.79661 17.2081C5.5051 16.8561 6.48931 16.5943 7.74199 16.4367C10.2451 16.122 13.7057 16.2372 17.8923 16.7673C26.2571 17.8264 37.413 20.527 49.3709 24.6237C61.3286 28.7205 71.7969 33.4285 79.0537 37.7215C82.6857 39.8701 85.4899 41.9012 87.2741 43.6848C88.167 44.5774 88.7839 45.3878 89.1276 46.1004C89.4705 46.8109 89.5219 47.379 89.3663 47.833Z",
    stroke: "url(#paint15_linear_734_766)",
    strokeWidth: 0.999783
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0262 15.6963C65.0699 12.6427 60.1981 12.5639 57.1445 15.5201C54.091 18.4763 54.0121 23.3482 56.9684 26.4017C59.9245 29.4552 64.7965 29.5341 67.85 26.5779C70.9035 23.6217 70.9824 18.7498 68.0262 15.6963Z",
    fill: "url(#paint16_radial_734_766)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_766",
    x1: 46.746,
    y1: 10.1064,
    x2: 46.746,
    y2: 51.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#C00606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947005,
    stopColor: "#FF8F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_734_766",
    x1: 47.2496,
    y1: 43.8379,
    x2: 47.2496,
    y2: 19.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_734_766",
    x1: 47.25,
    y1: 47.8711,
    x2: 47.25,
    y2: 46.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_734_766",
    x1: 47.25,
    y1: 46.6113,
    x2: 47.25,
    y2: 36.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_734_766",
    x1: 47.25,
    y1: 26.4766,
    x2: 47.25,
    y2: 16.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_734_766",
    x1: 47.25,
    y1: 15.8784,
    x2: 47.25,
    y2: 15.1126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_734_766",
    x1: 31.0404,
    y1: 31.8008,
    x2: 31.0404,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_734_766",
    x1: 34.9249,
    y1: 31.8008,
    x2: 34.9249,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_734_766",
    x1: 38.6904,
    y1: 31.8008,
    x2: 38.6904,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_734_766",
    x1: 40.7341,
    y1: 31.8008,
    x2: 40.7341,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_734_766",
    x1: 53.6153,
    y1: 31.8008,
    x2: 53.6153,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_734_766",
    x1: 55.5312,
    y1: 31.8008,
    x2: 55.5312,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_734_766",
    x1: 59.3312,
    y1: 31.8008,
    x2: 59.3312,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_734_766",
    x1: 63.3527,
    y1: 31.8008,
    x2: 63.3527,
    y2: 31.1832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_734_766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5809 60.3608) rotate(-43.7151) scale(25.992 33.4952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.581217,
    stopColor: "#2B152F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753744,
    stopColor: "#413686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963759,
    stopColor: "#5CB1E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_734_766",
    x1: 47.6172,
    y1: 41.1601,
    x2: 52.1163,
    y2: 28.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47974,
    stopColor: "#654BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303261",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_734_766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.3632 16.7003) rotate(148.456) scale(18.244 18.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357721,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#261C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866261,
    stopColor: "#582A60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.7969,
    height: 71.9844,
    fill: "white",
    transform: "translate(0.21875 0.168945)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_734_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    fill: "white",
    transform: "matrix(1 0 0 -1 29 49.1064)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLightningSniper);
export default __webpack_public_path__ + "static/media/img-lightning-sniper.eaa9bcb8b1f754ef2b5dacf005ee6a1e.svg";
export { ForwardRef as ReactComponent };